module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<h2>\n  You have less experience than our typical candidates for these roles.<br>\n  We want to help you increase your chances.\n</h2>\n<p>\n  Please explain why you would make a great employee and any other skills\n  or experiences that may be relevant:\n</p>\n\n<div class="form-group">\n  <span class="help-block hidden"></span>\n  <textarea class="bordered" id="self-promo"\n    placeholder="Go on, brag a little" maxlength="500">' +
((__t = ( self_promo )) == null ? '' : __t) +
'</textarea>\n    <div id="promo-char-count" class="textarea-counter" style="display:none;"></div>\n</div>\n';

}
return __p
}